import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonDataService } from './../../common-data.service';
import { SolicitacaoServicoService } from './../../api/services/solicitacao-servicos.service';
import { LocalService } from './../../api/services/local.service';
import { TiposDeServicoService } from './../../api/services/tipos-de-servico.service';
import { ModalService } from '../../shared/_services/index';
import { ToastsService } from './../../api/toasts/toasts.service';
import { UserService } from './../../api/services/user.service';
import { FuncionariosService } from './../../api/services/funcionarios.service';
declare var swal: any;

@Component({
  selector: 'app-excecoes',
  templateUrl: './excecoes.component.html',
  styleUrls: ['./excecoes.component.scss']
})
export class ExcecoesComponent implements OnInit {
	isFormLoading: boolean = false;
	tableSettings: any = {
		temp: [],
		reorderable: true,
		filterrows: [],
		isLoading: true
	}

	pageTitle: any = {
		title: 'Solicitação de serviços',
		breadcumbs: [
			{
				title: 'Dashboard',
				href: '/'
			}
		],
		breadcumbActive: 'Solicitação de serviços'
	}

	form: FormGroup;
	selected: any = {};
	isCreate: boolean = false;

	areas: any = []
	usuarios: any = []
	tiposServicos: any = []
	funcionarios: any = []

	constructor(private _commondata: CommonDataService,
				private service: SolicitacaoServicoService,
				private localService: LocalService,
				private tiposDeServicoService: TiposDeServicoService,
				private modalService: ModalService,
				private fb: FormBuilder,
				private userService: UserService,
				private funcionariosService: FuncionariosService,
				private toastsService: ToastsService)
	{
		this.form = this.fb.group({  
			descricao: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(2000)]),
			observacao: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(2000)]),
			codLocal: new FormControl('', [Validators.required]),
			// codServico: new FormControl('', [Validators.required]),
			codUsuarioSolicitante: new FormControl('', [Validators.required]),
			codFuncionario: new FormControl(''),
		});
	}

	ngOnInit() {
		this.load();
		this.localService.getAreas().subscribe((data: any[]) => {
			this.areas = data;
		});
		this.tiposDeServicoService.get().subscribe((data: any[]) => {
			this.tiposServicos = data;
		});
		this.userService.get().subscribe((data: any[]) => {
			this.usuarios = data;
		});
		this.funcionariosService.get().subscribe((data: any[]) => {
			this.funcionarios = data;
		});
	}

	load() {
		this.service.get().subscribe((data: any[]) => {
			this.tableSettings.temp = data;
			this.tableSettings.filterrows = data;
			this.tableSettings.isLoading = false;
			this.isFormLoading = false;
		});
	}

	addNew() {
		this.isCreate = true;
		this.form.reset();
		this.selected = {}
		this.modalService.open('modal');
	}

	onSelect(event) {
    if(event.type == 'click') {
			this.isCreate = false;
			this.selected = event.row;
			this.form.reset();
			this.form.patchValue(event.row);
			this.modalService.open('modal');
    }
	}

	onReload() {
		this.tableSettings.isLoading = true;
		this.load();
	}

	updateFilter(val) {
		const temp = this.tableSettings.temp.filter(function (d) {
			return (d.nome.toLowerCase().indexOf(val) !== -1 || 
				d.descricao.toLowerCase().indexOf(val) !== -1 ||
				d.area.nome.toLowerCase().indexOf(val) !== -1 ||
				d.tipoServico.nome.toLowerCase().indexOf(val) !== -1 ||
				d.usuario.email.toLowerCase().indexOf(val) !== -1 ||
				String(d.codigo).indexOf(val) !== -1 ) 
			|| !val;
		});

		this.tableSettings.filterrows = temp;
	}

	closeModal(id: string) {
		this.modalService.close(id);
	}

	submit() {
		if(this.form.valid) {
			this.isFormLoading = true;
			if(this.isCreate) {
				this.service.post(this.form.value).subscribe((data: any) => {
					this.closeModal('modal');
					this.toastsService.toastSuccess("Salvo com sucesso!");
					this.load();
				}, error => {
					this.isFormLoading = false;
					if (typeof error.error === 'string') {
						this.toastsService.toastError(error.error);
					}
					else if (error.error.errors) {
						let errorMessage = ""
						Object.getOwnPropertyNames(error.error.errors).forEach((field) => {
							errorMessage += error.error.errors[field]
						})

						this.toastsService.toastError(errorMessage);
					}
					else {
						this.toastsService.toastError("Revise todos os dados e tente novamente!");
					}
				});
			}
			else {
				this.service.patch(this.form.value, this.selected.codigo).subscribe(() => {
					this.closeModal('modal');
					this.toastsService.toastSuccess("Editado com sucesso!");
					this.load();
				}, error => {
					this.isFormLoading = false;
					if (typeof error.error === 'string') {
						this.toastsService.toastError(error.error);
					}
					else if (error.error.errors) {
						let errorMessage = ""
						Object.getOwnPropertyNames(error.error.errors).forEach((field) => {
							errorMessage += error.error.errors[field]
						})

						this.toastsService.toastError(errorMessage);
					}
					else {
						this.toastsService.toastError("Revise todos os dados e tente novamente!");
					}
				});
			}

		}
		else {
			this.validateAllFormFields(this.form);
		}
	}

	remove() {
		swal({
			text: 'Deseja realmente deletar esse Serviço?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#d33',
			cancelButtonColor: '#3085d6',
			cancelButtonText: 'Não!',
			confirmButtonText: 'Sim, deletar!'
		}).then((result) => {
			if (result.value) {
				this.isFormLoading = true;
				this.service.delete(this.selected.codigo).subscribe(() => {
					this.closeModal('modal');
					this.toastsService.toastSuccess("Deletado com sucesso!");
					this.load();
				}, error => {
					this.isFormLoading = false;
					this.toastsService.toastError("Tente novamente!");
				});
			}
		});
	}

	aprovar(event, aprovado, codigo) {
		event.stopPropagation();
		var msg = aprovado ? "Aprovar" : "Reprovar";
		swal({
			text: `Deseja realmente ${msg} esse Serviço?`,
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#d33',
			cancelButtonColor: '#3085d6',
			cancelButtonText: 'Não!',
			confirmButtonText: `Sim, ${msg}!`
		}).then((result) => {
			if (result.value) {
				this.isFormLoading = true;
				var body = {
					aprovado: aprovado
				};
				this.service.patch(body, codigo).subscribe(() => {
					this.toastsService.toastSuccess("Editado com sucesso!");
					this.load();
				}, error => {
					this.isFormLoading = false;
					if (typeof error.error === 'string') {
						this.toastsService.toastError(error.error);
					}
					else if (error.error.errors) {
						let errorMessage = ""
						Object.getOwnPropertyNames(error.error.errors).forEach((field) => {
							errorMessage += error.error.errors[field]
						})

						this.toastsService.toastError(errorMessage);
					}
					else {
						this.toastsService.toastError("Revise todos os dados e tente novamente!");
					}
				});
			}
		});
	}

	campoValido(nomeCampo) {
		return !this.form.get(nomeCampo).valid && (this.form.get(nomeCampo).dirty || this.form.get(nomeCampo).touched)
	}

	validateAllFormFields(formGroup: FormGroup) {
		Object.keys(formGroup.controls).forEach(field => { 
			const control = formGroup.get(field);            
			if (control instanceof FormControl) {            
				control.markAsTouched({ onlySelf: true });
			} else if (control instanceof FormGroup) {       
				this.validateAllFormFields(control);           
			}
		});
	}
}
